import { useCallback, useEffect } from "react"
import apiSlice from "./apiSlice"
import { ApiTag } from "./util/ApiTag"
import { useTenantSubDomain } from "../../components/tenancy/TenantHooks"
import usePrevious from "../../hooks/usePrevious"
import { useDispatch } from "react-redux"

const useTenantStateManager = () => {
	const tenantSubDomain = useTenantSubDomain()
	const previous = usePrevious(tenantSubDomain)
	const dispatch = useDispatch()
	const invalidateTenantState = useCallback(() => {
		console.log("Tenant changed. Invalidating state.", {
			current: tenantSubDomain,
			previous: previous
		})
		dispatch(apiSlice.util.invalidateTags([ApiTag.Tenant]))
	}, [dispatch, previous, tenantSubDomain])

	useEffect(() => {
		if (previous === tenantSubDomain) {
			return
		}
		invalidateTenantState()
	}, [invalidateTenantState, previous, tenantSubDomain])
}

export default useTenantStateManager
